import BaseValidator from 'services/validations/base-validator';

class AtLeastOneCombinationWithExposureMoreThanZeroValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;

        if (0 >= stacking.getTotalMaxExposureOfCheckedStackCombinations()) {
            this.addError('Should be at least one combination with exposure more than 0.');
        }
    }
}

export default AtLeastOneCombinationWithExposureMoreThanZeroValidator;
